import { Backdrop, Box } from '@mui/material';
import { QButton, QCard, QTypography } from '@kw/quokka-ui';

export const LoggedOutOverlay = ({ onReload }: { onReload: () => void }) => {
  return (
    <Backdrop
      open
      sx={{
        zIndex: 999999,
        color: '#000',
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(0,0,0,0.55)',
        p: 3,
      }}
    >
      <QCard variant="outlined" sx={{ width: '100%', maxWidth: 480, p: 3, borderRadius: 2, boxShadow: 6 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <QTypography variant="h4Medium" component="h2">
            You were logged out
          </QTypography>
          <QTypography variant="bodyRegular">Another tab logged out. Reload to sign in again.</QTypography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
            <QButton variant="contained" color="primary" onClick={onReload}>
              Reload
            </QButton>
          </Box>
        </Box>
      </QCard>
    </Backdrop>
  );
};
